// Cihaz Politikası (sunucu tarafı, donanım) — kullanıcı yetkisinden AYRI.
// Bir lokasyondaki tüm terminaller için hangi donanım davranışının açık olduğunu belirler.
import api from "@/lib/api";

let _cache = null;

export const loadDevicePolicy = async () => {
  try {
    const { data } = await api.get("/settings/device-policy");
    _cache = data;
    return data;
  } catch {
    return _cache;
  }
};

export const getDevicePolicy = () => _cache;

// Etkin değer: önce lokasyon override, yoksa default, yoksa verilen varsayılan.
export const policyFlag = (key, locId, def = true) => {
  if (!_cache) return def;
  const loc = locId && _cache.locations && _cache.locations[locId];
  if (loc && key in loc) return !!loc[key];
  const d = _cache.default || {};
  return key in d ? !!d[key] : def;
};
